import React, { useState, useEffect, useRef } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Select, Input, Button, Space, Divider, message } from "antd";

export const HospitalSelect = ({
  hospitalNames = [],
  selectedClinic,
  onChange,
}) => {
  console.log("selectedClinicvalueHospitalSelect:::", selectedClinic);

  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const inputRef = useRef(null);

  // Sync incoming hospitalNames, assign unique IDs if missing
  useEffect(() => {
    const withIds = hospitalNames.map((h, idx) => ({
      id: h.id ?? idx + 1, // fallback id if not provided
      name: `${h.name} (${h.mailId})`,
      isNew: false,
    }));
    setOptions(withIds);
  }, [hospitalNames]);

  const handleAddNew = (e) => {
    e.preventDefault();
    const newName = inputValue.trim();

    if (!newName) {
      message.warning("Please enter a hospital name");
      return;
    }

    // Always assign a unique ID
    const newId = Date.now(); // or use UUID if needed
    const newHospital = { id: newId, name: newName, isNew: true };

    setOptions((prev) => [...prev, newHospital]);
    onChange(newHospital);
    setInputValue("");
    setSearchValue("");
    // message.success(`Added new: ${newName}`);
  };

  const handleSearch = (val) => setSearchValue(val);
  const handleInputChange = (e) => setInputValue(e.target.value);
  const handleChange = (value) => {
    const selected = options.find((h) => h.id === value);
    console.log("selected::::", value, selected, options);
    onChange(selected ?? { name: value, isNew: true }); // fallback if not found
    setSearchValue("");
  };

  const filteredOptions = options.filter((opt) =>
    opt.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <Select
      showSearch
      size="large"
      value={selectedClinic?.id || null}
      onChange={handleChange}
      onSearch={handleSearch}
      searchValue={searchValue}
      filterOption={false}
      placeholder="Select Provider or Add New"
      dropdownRender={(menu) => (
        <>
          {menu}
          <Divider style={{ margin: "8px 0" }} />
          <Space style={{ padding: "0 8px 4px" }}>
            <Input
              placeholder="Enter New Provider"
              ref={inputRef}
              value={inputValue}
              onChange={handleInputChange}
              onPressEnter={handleAddNew}
            />
            <Button
              type="text"
              icon={<PlusOutlined />}
              onClick={handleAddNew}
              disabled={!inputValue.trim()}
            >
              Add
            </Button>
          </Space>
        </>
      )}
      options={filteredOptions.map((opt) => ({
        label: opt.name,
        value: opt.id, // 👈 must be unique
      }))}
    />
  );
};
